/**
 * Dialog wrapper around <UnitCommandsPanel>.
 *
 * Drop-in replacement for the legacy AdminUnitCommandsDialog /
 * UnitCommandsDialog. The catalog endpoint already does role-based
 * filtering, so we render one panel for everyone — staff, customer-
 * admin, and site-group-admin all see the same component, just with
 * different commands inside it.
 *
 * For commands declared with `params: "custom"` (TIME_SET,
 * NETWORK_SET, THRESHOLDS_SET, FIRMWARE_UPGRADE, etc.) the panel
 * emits `onCustomCommand` and we delegate to whatever the caller
 * wires up. During the transition we fall back to the legacy
 * AdminUnitCommandsDialog; remove that fallback once each custom
 * spec ships declared params.
 */

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import UnitCommandsPanel from '@sophocles/views/sites/components/UnitCommandsPanel';

export default function UnitCommandsPanelDialog({
  open,
  onClose,
  siteId,
  unitId,
  unitModelId = null,
  relays = [],
  onCustomCommand,
  onCommandSent,
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ flex: 1 }}>{t('sites.sendCommands')}</span>
        <IconButton size="small" onClick={onClose} aria-label={t('actions.close', 'Close')}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <UnitCommandsPanel
          siteId={siteId}
          unitId={unitId}
          unitModelId={unitModelId}
          relays={relays}
          onCustomCommand={onCustomCommand}
          onCommandSent={onCommandSent}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
